/* tw-rebel.js — homepage interactions (scroll reveal + sticky header state)
   Loaded on the homepage only. No external dependencies. */
(function () {
  function init() {
    // Scroll reveal
    var revealEls = document.querySelectorAll('.tw-rebel .reveal-up, .tw-rebel .reveal-scale');
    if ('IntersectionObserver' in window && revealEls.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
            io.unobserve(entry.target);
          }
        });
      }, { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      // Fallback: no observer support -> show everything
      revealEls.forEach(function (el) { el.classList.add('active'); });
    }

    // Header scroll state (adds .tw-header--scrolled after 50px)
    var header = document.querySelector('[data-tw-header]');
    if (header) {
      var onScroll = function () {
        if (window.scrollY > 50) header.classList.add('tw-header--scrolled');
        else header.classList.remove('tw-header--scrolled');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Mobile menu toggle
    var toggle = document.querySelector('[data-tw-menu-toggle]');
    var nav = document.querySelector('[data-tw-mobile-nav]');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      nav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          nav.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
